import styled from 'styled-components';

const YTVideoDetailHolder = styled.div`
	.yt-video-embed {
		clear: both;
		display: flex;
		justify-content: space-around;
		flex-flow: row;
		align-items: stretch;
		padding-top: 20px;
		padding-bottom: 20px;
		iframe {
			height: 500px;
			width: 890px;
			margin: 0 auto;
			border: 0;
			transition: all .1s ease-in-out;
			margin: 0 auto;

			@media only screen and (max-width: 920px) {
				width: 100%;
				height: 400px;
			}
			@media only screen and (max-width: 500px) {
				width: 100%;
				height: 400px;
			}
		}
	}
`;

export default YTVideoDetailHolder;